import { TrendingDown } from "lucide-react";
import { Badge, cn } from "web-design-system";
import { PortfolioReviewLine } from "creso-core/types";
import { AmcLogo } from "@core/components/logo/amc-logo";

type SourceLabel = PortfolioReviewLine["source_label"] | "Existing";

const SOURCE_BADGE: Record<SourceLabel, string> = {
  Internal: "bg-tag-slate text-tag-slate-foreground",
  External: "bg-tag-orange text-tag-orange-foreground",
  New: "bg-tag-blue text-tag-blue-foreground",
  Existing: "bg-tag-slate text-tag-slate-foreground",
};

const QUARTILE_BADGE: Record<number, string> = {
  1: "bg-tag-green text-tag-green-foreground",
  2: "bg-tag-lime text-tag-lime-foreground",
  3: "bg-tag-yellow text-tag-yellow-foreground",
  4: "bg-tag-red text-tag-red-foreground",
};

export function SourceBadge({ label }: { label: SourceLabel }) {
  return (
    <Badge
      variant="custom"
      className={cn("font-semibold", SOURCE_BADGE[label])}
    >
      {label}
    </Badge>
  );
}

export function QuartileBadge({ quartile }: { quartile: number | null }) {
  if (!quartile) return "-";
  return (
    <Badge
      variant="custom"
      className={cn("font-semibold", QUARTILE_BADGE[quartile])}
    >
      Q{quartile}
    </Badge>
  );
}

export function FundCell({
  name,
  category,
  amcCode,
  quartile,
  className,
}: {
  name: string;
  category?: string | null;
  amcCode: string | null;
  quartile?: number | null;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-3 max-w-90", className)}>
      <AmcLogo amc_code={amcCode} />
      <div className="flex min-w-0 flex-col gap-1">
        <span className="flex items-center gap-2">
          <span className="line-clamp-2 text-sm">{name}</span>
          {quartile && quartile >= 3 ? (
            <TrendingDown
              aria-label="Underperforming"
              className="size-4 shrink-0 text-tag-orange-foreground"
            />
          ) : null}
        </span>
        {category ? (
          <span className="truncate text-xs text-muted-foreground">
            {category}
          </span>
        ) : null}
      </div>
    </div>
  );
}
